export const DEFAULT_CITY = 'Québec';

export function capitalize(str: string) {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
}